<div id="add-edit-doctor-visits">
    <h2 class="m-b-5" mat-dialog-title>{{title}}</h2>
    <div mat-dialog-content>
        <form [formGroup]="doctorVisitForm">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="50">
                    <mat-form-field class="w-100-p">
                        <mat-label>Fecha</mat-label>
                        <input matInput [matDatepicker]="dateDP" formControlName="Date"
                            autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="dateDP"></mat-datepicker-toggle>
                        <mat-datepicker #dateDP></mat-datepicker>
                    </mat-form-field>
                    <mat-error
                        *ngIf="doctorVisitForm.get('Date').invalid && doctorVisitForm.get('Date').touched && !doctorVisitForm.get('Date').errors.required"
                        class="error-space">
                        <span>El formato de fecha no es válido (DD/MM/YYYY)</span>
                    </mat-error>
                    
                    <mat-error *ngIf="doctorVisitForm.get('Date').invalid && doctorVisitForm.get('Date').touched && doctorVisitForm.get('Date').errors.required"
                        class="error-space">
                        <span>Obligatorio</span>
                    </mat-error>
                </div>
                <div class="widget" fxFlex.gt-sm="50">
                    <mat-form-field class="w-100-p">
                        <mat-label>Coordinador</mat-label>
                        <mat-select formControlName="Coordinator">
                            <mat-option *ngFor="let coordinador of coordinatorList$" [value]="coordinador.viewValue">{{coordinador.viewValue}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="doctorVisitForm.get('Coordinator').invalid && doctorVisitForm.get('Coordinator').touched"
                        class="error-space">
                        <span>Obligatorio</span>
                    </mat-error>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Asistentes</mat-label>
                        <input matInput formControlName="Assistant" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Resumen</mat-label>
                        <textarea matInput formControlName="Comments" autocomplete="off" rows="3"></textarea>
                    </mat-form-field>
                    <mat-error *ngIf="doctorVisitForm.get('Comments').invalid && doctorVisitForm.get('Comments').touched"
                        class="error-space">
                        <span>El número máximo de caracteres permitido es 500</span>
                    </mat-error>
                </div>
            </div>
        </form>
    </div>
    <div class="text-a-r  m-t-10 m-b-10">
        <button mat-raised-button color="accent" (click)="saveDoctorVisit()" class="m-r-15">Guardar</button>
        <button mat-raised-button (click)="cancel()" color="warn">Cancelar</button>
    </div>
</div>